module.exports = __webpack_public_path__ + "static/img/aboutPic2.d8b5d09.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutPic2.png
// module id = UEYd
// module chunks = 1